import { apiQuery, atsApiQuery } from '..';
import { getEmailFormData } from './utils';

export const sendEmailAtsApi = atsApiQuery.injectEndpoints({
  endpoints: (builder) => {
    return {
      sendEmailActivityForCandidate: builder.mutation({
        transformResponse: (response) => response?.data,
        query: ({ params }) => {
          const fd = new FormData();
          const formData = getEmailFormData(fd, params);

          return {
            url: `/ats_candidate_messages`,
            method: 'post',
            data: formData,
          };
        },
      }),
      cancelEmailActivity: builder.mutation({
        transformResponse: (response) => response?.data,
        query: ({ messageId }) => {
          return {
            url: `/ats_candidate_messages/${messageId}`,
            method: 'delete',
          };
        },
      }),
      cancelEmailActivityStage: builder.mutation({
        transformResponse: (response) => response?.data,
        query: ({ messageId, stageId }) => {
          return {
            url: `/ats_candidate_messages/${messageId}/cancel`,
            method: 'post',
          };
        },
      }),
      getEmailActivityMessage: builder.query({
        transformResponse: (response) => response?.data,
        query: ({ messageId }) => {
          return {
            url: `/ats_candidate_messages/${messageId}`,
            method: 'get',
          };
        },
      }),
      getEmailActivityMessageById: builder.mutation({
        transformResponse: (response) => response?.data,
        query: ({ messageId }) => {
          return {
            url: `/ats_candidate_messages/${messageId}`,
            method: 'get',
          };
        },
      }),
      updateEmailActivityMessage: builder.mutation({
        transformResponse: (response) => response?.data,
        query: ({ params, messageId }) => {
          const fd = new FormData();
          const formData = getEmailFormData(fd, params);
          return {
            url: `/ats_candidate_messages/${messageId}`,
            method: 'put',
            data: formData,
          };
        },
      }),
    };
  },
  overrideExisting: true,
});

export const {
  useSendEmailActivityForCandidateMutation,
  useCancelEmailActivityMutation,
  useGetEmailActivityMessageQuery,
  useUpdateEmailActivityMessageMutation,
  useGetEmailActivityMessageByIdMutation,
  useCancelEmailActivityStageMutation,
} = sendEmailAtsApi;

export const sendEmailApi = apiQuery.injectEndpoints({
  endpoints: (builder) => {
    return {
      sendEmailConversationReply: builder.mutation({
        transformResponse: (response) => response?.data,
        query: ({ candidate_message_id, params }) => {
          const formData = new FormData();
          const emailFormData = getEmailFormData(formData, params);
          return {
            url: `candidate_messages/${candidate_message_id}/replies`,
            method: 'post',
            data: emailFormData,
          };
        },
      }),
    };
  },
  overrideExisting: true,
});

export const { useSendEmailConversationReplyMutation } = sendEmailApi;
